module.exports = __webpack_public_path__ + "static/media/portfolio1 (51).f3672d80.jpeg";